import React, { useState, useEffect } from "react";
import "../styles/corporate.css";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import moment from "moment";
import { useToasts } from "react-toast-notifications";
import apiCallService from "../../service/api-call-service";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import { store } from "../../redux/store";
import { setActiveHeader } from "../../redux/activeHeader/activeheader.action";
import Pagination from "react-js-pagination";
import Avatar from "react-avatar";
import CommonFunction from "../../common-function/GenerateRequestId";
import CorpLoader from "../component/corporate.loader";
import Can from "../../auth/can/Can";
import ResetLoginPassword from "../../corporate-profile/component/reset-login-password";
const collectedTrueKeys = {
  is_active: [],
};

var ToDateVar = "";
var FromDateVar = "";

const CorporateList = ({
  authenticated,
  userRole,
  roleData,
  token,
  roMdn,
  isPasswordReset,
}) => {
  const corplistpage = sessionStorage.getItem("corplistpage") || 1;
  const [loading, setLoading] = useState(true);
  const { addToast } = useToasts();

  const [currentPage, setCurrentPage] = useState(corplistpage);
  const [postsPerPage, setPostsPerPage] = useState(
    process.env.REACT_APP_VAR_FOR_CORP_LIST_NUMER_OF_POST_PER_PAGE
  );

  const [multiValueRecords, setMultiRecords] = useState([
    { value: 1, label: "Active" },
    { value: 0, label: "In-Active" },
  ]);
  const [placeHolder, setplaceHolder] = useState("...");
  const [multiValueRecord, setMultiValueRecord] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPost, setcurrentPost] = useState([]);
  const [searchCorp, setSearchCorp] = useState("");
  const [searchVariable, setSearchVariable] = useState("");
  const [filteredRecord, setFilteredRecord] = useState([]);
  const [allValuesForFilter, setAllValuesForFilter] = useState([]);
  const [allCorpBalanceList, setAllCorpBalanceList] = useState([])
  const [corpDetail, setCorpDetail] = useState([]);
  const [currentPostWithBalanace, setCurrentPostWithBalanace] = useState([]);
  const [size, setSize] = useState(0);
  const [totalBalanceofCorps, setTotalBalanceofCorps] =useState('')

  useEffect(() => {
    document.title = "ZRO Corporate List";

    var payload = {
      dashBoardClass: "",
      manageEmployeeClass: "",
      moneyDisbursalClass: "",
      manageCardClass: "",
      manageLimitClass: "",
      activityClass: "",
      corpListClass: "active",
    };

    store.dispatch(setActiveHeader(payload));

    getCorpDetail();
  }, []);

  useEffect(() => {
    if (searchCorp == "" && corpDetail.length > 0) {
      setFilteredRecord([...corpDetail]);
    }
  }, [searchCorp]);

  useEffect(() => {
    if (currentPost.length > 0 && allCorpBalanceList.length > 0) {
      const corplistwithBalance = currentPost.map(val=>{
        const matchbalanceWithroid = allCorpBalanceList.filter(data=>data.roId == val.roId)
        let balance = Array.isArray(matchbalanceWithroid) && matchbalanceWithroid[0]?.balance
        val.balance = balance
        return val
      })
      setCurrentPostWithBalanace(corplistwithBalance)
    }
  }, [currentPost, allCorpBalanceList]);

  const getCorpDetail = async () => {
    var url = `${process.env.REACT_APP_GET_CORP_LIST_BY_RO_CREATED}?createdByRoId=${roMdn}`;
    var result = await apiCallService.getMethodCallWithoutParam(url);


    if (
      result !== undefined &&
      result.response_code !== undefined &&
      result.response_code === 0 &&
      result.response !== undefined
    ) {
      setCorpDetail(result.response);
      setFilteredRecord(result.response);

      setLoading(false);
    } else {
      setLoading(false);
    }
  };


  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    sessionStorage.setItem("corplistpage", pageNumber);
  };

  const handleDateChange = async (event) => {
    console.log(event.target.value, " : ", event.target.name);
    const { value, name } = event.target;
    if (name === "toDate") {
      setToDate(value);
      ToDateVar = value;
    }
    if (name === "fromDate") {
      setFromDate(value);
      FromDateVar = value;
    }

    if (ToDateVar !== "" && FromDateVar !== "") {
      var formatFromDate = moment(FromDateVar).format("YYYY-MM-DD");
      var formatToDate = moment(ToDateVar).format("YYYY-MM-DD");

      const url = process.env.REACT_APP_GET_ALL_CORPORATE_LIST;


      var request = {
        fromDate: `${formatFromDate}`,
        toDate: `${formatToDate}`,
      };

      var response = await apiCallService.postMethodCall(url, request);

      if (
        response !== undefined &&
        response.response_code === 0 &&
        response.response !== undefined
      ) {
        setFilteredRecord(response.response);
        setCurrentPage(1);
      } else {
        setFilteredRecord([]);
      }
    }
  };

  const handleMultiRecordchange = (option) => {

    setMultiValueRecord(option);
    setCurrentPage(1);

    collectedTrueKeys.is_active = [];
    if (option !== null) {
      option.map((op) => {
        collectedTrueKeys.is_active.push(op.value);
      });
    }

    var data = [];
    if (allValuesForFilter.length === 0) {
      setAllValuesForFilter(option);
    } else {
      allValuesForFilter.map((all) => {
        data.push(all);
      });
      option !== null &&
        option.map((op) => {
          data.push(op);
        });
      setAllValuesForFilter(data);
    }
  };
  const handleSearchCoprs = (e) => {
    const { value } = e.target;

    setSearchCorp(e.target.value);
    if (value == "") {
      setSearchVariable(value);
      setCurrentPage(1);
    }
  };

  const searchCorps = async (search) => {
    const url = `${process.env.REACT_APP_GET_SEARCH_CORPORATE_LIST_BY_MOBILE}${searchCorp}`;
    if (search == "By Emp Mobile") {
      var result = await apiCallService.getMethodCallWithoutParam(url);
      if (
        result !== undefined &&
        result.response_code !== undefined &&
        result.response_code === 0 &&
        result.response !== undefined &&
        result?.response !== null
      ) {
        setFilteredRecord(result.response);
        setCurrentPage(1);
      } else if (
        result !== undefined &&
        result?.response_code !== undefined &&
        result?.response_code === 0 &&
        result?.response !== undefined &&
        result?.response == null
      ) {
        const Message =
          process.env.REACT_APP_MESSAGE_FOR_EMP_NOT_FOUND_BY_MOBILE;
        addToast(Message, {
          appearance: "warning",
          autoDismiss: true,
          autoDismissTimeout: 7000,
        });
      } else {
        console.log("not found");
      }
    } else {
      setSearchVariable(searchCorp);
      setCurrentPage(1);
    }
  };

  const clearAll = () => {
    setFilteredRecord(corpDetail);
    setMultiValueRecord([]);

    ToDateVar = "";
    FromDateVar = "";

    setAllValuesForFilter([]);
    collectedTrueKeys.is_active = [];
    setToDate("");
    setFromDate("");


  };

  const handleSearchChange = (event) => {
    setSearchVariable(event.target.value);
    setCurrentPage(1);
  };
  const exportCsv = async () =>{
    let currentDate = moment();
    currentDate = currentDate.format("YYYY-MM-DD HH:mm:ss");
    let temp = [...allCorpBalanceList]
    temp.push({roId:"Total Balance", name:'', balance:totalBalanceofCorps})
    const csv = convertArrayToCSV(temp);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, `corp-balance-report-${currentDate}.csv`); 
}
const fetchNewBalance = async () =>{
  const url = process.env.REACT_APP_GET_ALL_CORPORATE_BALANCE;
    var result = await apiCallService.getMethodCallWithoutParam(url);
    if (
      result !== undefined &&
      result.response_code !== undefined &&
      result.response_code === 0 &&
      result.corpBalances !== undefined &&
      result?.corpBalances !== null
    ) {
      let finalBalance = await result.corpBalances
      setTotalBalanceofCorps(result.totalBalance)
      setAllCorpBalanceList(finalBalance)
    }
}

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px solid #ddd",
      borderRadius: "0",
      boxSizing: "content-box",
      minHeight: "30px",
      lineHeight: "18px",
      display: "flex",
    }),

    valueContainer: (base) => ({
      ...base,
      position: "relative",
      overflow: "hidden",
      margin: "0",
      padding: "5px",
      width: "100%",
      minHeight: "30px",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      lineHeight: "18px",
      cursor: "text",
      alignItems: "center",
    }),
    multiValue: (base) => ({
      ...base,
      boxSizing: "content-box",
      position: "relative",
      margin: "1px 5px 1px 0px",
      padding: "1px 2px 3px 5px",
      border: "1px solid #c4d5e1",
      lineHeight: "18px",
      maxWidth: "100%",
      borderRadius: "3px",
      backgroundColor: "#d6eeff",
      boxShadow: "0 0 2px #fff inset, 0 1px 0 rgba(0, 0, 0, 0.05)",
      color: "#4a546c",
      lineHeight: "16px",
      cursor: "default",
      height: "20px",
    }),
    menu: (base) => ({
      ...base,
      padding: "2px 5px",
      lineHeight: "16px",
    }),
    input: (base) => ({
      ...base,
      height: "18px",
      lineHeight: "18px",
    }),
  };

  const multiPropsFilter = (products, filters) => {
    const filterKeys = Object.keys(filters);
    return products.filter((product) => {
      return filterKeys.every((key) => {
        if (!filters[key].length) return true;
        // Loops again if product[key] is an array (for material attribute).
        if (Array.isArray(product[key])) {
          return product[key].some((keyEle) => filters[key].includes(keyEle));
        }
        return filters[key].includes(product[key]);
      });
    });
  };

  // var currentPost = [];
  //Get Current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const valueToShow = indexOfFirstPost + 1;

  var filteredPost = [];

  if (
    filteredRecord === null ||
    !(filteredRecord !== undefined && filteredRecord.length && filteredRecord)
  ) {
    filteredPost = filteredRecord;
  } else if (filteredRecord.length !== 0) {
    filteredPost = multiPropsFilter(filteredRecord, collectedTrueKeys);

  }


  const filteredPostData = filteredPost;

  var searchedBy = [
    { searchKeyword: "By Emp Mobile" },
    { searchKeyword: "By Corp Name" },
  ];
  var searchedRecord = [];

 

  useEffect(() => {
    if (searchVariable !== "" && corpDetail !== undefined) {
      corpDetail.map((post) => {
        if (
          post.name !== undefined &&
          post.name !== null &&
          post.name.toLowerCase().includes(searchVariable.toLowerCase())
        ) {
          searchedRecord.push(post);
        } else if (
          post.roId !== undefined &&
          post.roId !== null &&
          post.roId.includes(searchVariable)
        ) {
          searchedRecord.push(post);
        } else if (
          post.contact_person !== undefined &&
          post.contact_person !== null &&
          post.contact_person.includes(searchVariable)
        ) {
          searchedRecord.push(post);
        }
      });
    }
    if (searchVariable !== "") {
    //   console.log("inside searchVariable ");
      const currentPost = searchedRecord.slice(
        indexOfFirstPost,
        indexOfLastPost
      );
      // size = searchedRecord.length;
      setSize(searchedRecord.length);
      setcurrentPost(currentPost);
      setCurrentPostWithBalanace(currentPost);
    } else {
      if (filteredPostData === null || filteredPostData === undefined) {
        // console.log("inside filteredPostData ");
        const currentPost = null;
        setCurrentPostWithBalanace(currentPost);
      } else {
        // console.log("inside filteredPostData else");
        const currentPost = filteredPostData.slice(
          indexOfFirstPost,
          indexOfLastPost
        );
        // size = filteredPostData.length;
        setSize(filteredPostData.length);
        setcurrentPost(currentPost);
        setCurrentPostWithBalanace(currentPost);
      }
    }
  }, [searchVariable, corpDetail, filteredRecord, currentPage]);



  var startdateToDate = moment();
  startdateToDate = startdateToDate.format("YYYY-MM-DD");

  if (toDate === "") {
    var startdateFromDate = moment();
    startdateFromDate = startdateFromDate.format("YYYY-MM-DD");
  } else {
    var startdateFromDate = moment(toDate);
    startdateFromDate = startdateFromDate.format("YYYY-MM-DD");
  }

  var dateMax = moment(fromDate);
  dateMax = dateMax.format("YYYY-MM-DD");
  var dateFromMax = moment(toDate);
  dateFromMax = dateFromMax.format("YYYY-MM-DD");

  var height = window.innerHeight - 250;

  useEffect(() => {
    if (currentPost.length > 0) {
      const getCorpBalance = async () => {
      await fetchNewBalance()
      };
      getCorpBalance();
    }
    return () => {
      // this now gets called when the component unmounts
      console.log("unmount");
    };
  }, [currentPost]);
 
  return (
    <>
      {authenticated ? (
        <Can
          role={userRole}
          perform="subheader-corpManage:visit"
          roleData={roleData}
          yes={() => (
            <>
              {isPasswordReset ? (
                <div className="emp-container">
                  <div className="container-fluid">
                    <div className="emp-list">
                      <div className="row">
                        <div className="col-12 ">
                          <div className="head">
                            <div className="head-right">
                              <div
                                className="dropdown float-right"
                                data-toggle="tooltip"
                                title="Filter"
                              >
                                <a
                                  href="#"
                                  className="fil-btn"
                                  id=""
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  Filter
                                </a>
                                <form>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <div className="filters">
                                      <label for="select-state">Type:</label>

                                      <Select
                                        name="multiTypeValue"
                                        placeholder={placeHolder}
                                        value={multiValueRecord}
                                        options={multiValueRecords}
                                        onChange={handleMultiRecordchange}
                                        isMulti={true}
                                        components={{
                                          DropdownIndicator: () => null,
                                          IndicatorSeparator: () => null,
                                          IndicatorsContainer: () => null,
                                        }}
                                        styles={customStyles}
                                      />
                                    </div>

                                    <div className="filters">
                                      <label htmlFor="select-state">
                                        From Date:
                                      </label>
                                      <input
                                        type="date"
                                        name="fromDate"
                                        id="fromDate"
                                        max={startdateFromDate}
                                        value={fromDate}
                                        onKeyDown={(e) => e.preventDefault()}
                                        onChange={handleDateChange}
                                      />
                                    </div>

                                    <div className="filters">
                                      <label htmlFor="select-state">
                                        To Date:
                                      </label>
                                      <input
                                        type="date"
                                        name="toDate"
                                        id="toDate"
                                        min={dateMax}
                                        max={startdateToDate}
                                        value={toDate}
                                        onKeyDown={(e) => e.preventDefault()}
                                        onChange={handleDateChange}
                                      />
                                    </div>

                                    <div className="fbtn">
                                      <button
                                        className="sbtn btnrd"
                                        type="reset"
                                        id="btnClear"
                                        onClick={clearAll}
                                      >
                                        Clear all
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>

                              <div
                                style={{ width: "auto", marginLeft: "5px" }}
                                className="head-btn"
                              >
                                <a href="/add-new-corp" className="admin">
                                  {
                                    process.env
                                      .REACT_APP_Var_FOR_CORP_LIST_Add_New_Corporate_BUTTON
                                  }
                                </a>
                              </div>
                              <div
                                style={{ width: "auto", marginLeft: "5px" }}
                                className="head-btn"
                              >
                              {  <button  onClick={exportCsv} style={{paddingLeft: '10px'}}>
                                 {process.env.React_APP_Var_FOR_CORP_BALANCE_EXPORT}
                                </button>}
                              </div>

                              <div id="search-corps" className="search ">
                                <input
                                  id="search-corps-input"
                                  type="text"
                                  value={searchCorp}
                                  name=""
                                  placeholder={"Enter mobile or Name"}
                                  onChange={handleSearchCoprs}
                                />
                                {searchCorp.length > 0 && (
                                  <div
                                    className="searchlist searchcorp-option"
                                    id="showemp1"
                                  >
                                    {searchedBy.map((record) => (
                                      <div
                                        onClick={() =>
                                          searchCorps(record.searchKeyword)
                                        }
                                      >
                                        <a className="oneSearch">
                                          {record.searchKeyword}
                                        </a>{" "}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                            <h3>
                              {
                                process.env
                                  .REACT_APP_Var_FOR_CORP_LIST_Corporate_List
                              }
                            </h3>
                          </div>
                        </div>

                        <div className="col-12 ">
                          <div style={{ minHeight: height }}>
                            <div className="row">
                              {loading ? (
                                <CorpLoader />
                              ) : currentPostWithBalanace !== null &&
                                currentPostWithBalanace !== "" &&
                                currentPostWithBalanace.length === 0 ? (
                                <div className="col-12">
                                  <div className="no-record">
                                    <i></i>
                                    <h3> No Record Available.</h3>
                                  </div>
                                </div>
                              ) : Array.isArray(currentPostWithBalanace) &&
                                currentPostWithBalanace.length > 0 ? (
                                <>
                                  {currentPostWithBalanace.map((corp) => (
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                                      <div className="corp-card">
                                        <Link
                                          to={{
                                            pathname: "/corp-profile",
                                            state: { roId: corp.roId },
                                          }}
                                        >
                                          <div className="corp-basic">
                                            <Avatar
                                              src={corp.logoUrl}
                                              color={Avatar.getRandomColor(
                                                corp.roId,
                                                [
                                                  "#F44336",
                                                  "#EC407A",
                                                  "#AB47BC",
                                                  "#7E57C2",
                                                  "#5C6BC0",
                                                  "#42A5F5",
                                                  "#29B6F6",
                                                  "#26C6DA",
                                                  "#26A69A",
                                                  "#66BB6A",
                                                  "#9CCC65",
                                                  "#D4E157",
                                                  "#FF7043",
                                                  "#FFEE58",
                                                  "#BDBDBD",
                                                ]
                                              )}
                                              name={corp.name}
                                              size="48px"
                                              round={true}
                                            />

                                            <h5>
                                              {CommonFunction.Capitalize(
                                                corp.name
                                              )}
                                            </h5>
                                            <p>
                                              {
                                                process.env
                                                  .REACT_APP_VARIABLE_FOR_CORPORATE_LIST_CARD_ROID
                                              }{" "}
                                              {corp.roId}
                                            </p>
                                          </div>
                                          {/* <div style={{display: ''}} > */}
                                          {corp.is_active === 1 ? (
                                            <div
                                              style={{
                                                display: "inlineBlock",
                                                width: "50%",
                                              }}
                                              className="corp-status"
                                            >
                                              <i className="active"></i> Active
                                              Corporate
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                display: "inlineBlock",
                                                width: "50%",
                                              }}
                                              className="corp-status"
                                            >
                                              <i className="inactive"></i>{" "}
                                              Inactive Corporate
                                            </div>
                                          )}
                                          {corp?.balance !==
                                            undefined && (
                                            <div
                                              style={{
                                                float: "right",
                                                marginTop: "10px",
                                                width: "auto",
                                                fontWeight: "bold",
                                              }}
                                              className="corp-status"
                                            >
                                              {"\u20B9"}{" "}
                                              {corp?.balance ||
                                                0}
                                            </div>
                                          )}
                                          {/* </div> */}
                                        </Link>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="col-12">
                                  <div className="no-record">
                                    <i></i>
                                    <h3> No Record Available.</h3>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="w-100 mt-3"></div>

                        {!loading && parseInt(size) > parseInt(postsPerPage) ? (
                          <>
                            <div className="col-12 col-sm-6">
                              <p>
                                Showing {valueToShow} to{" "}
                                {indexOfLastPost > size
                                  ? size
                                  : indexOfLastPost}{" "}
                                of {size} entries
                              </p>
                            </div>

                            <div className="col-12 col-sm-6">
                              <div className="pager">
                                <Pagination
                                  activePage={parseInt(currentPage)}
                                  itemsCountPerPage={parseInt(postsPerPage)}
                                  totalItemsCount={size}
                                  pageRangeDisplayed={parseInt(postsPerPage)}
                                  onChange={paginate}
                                  className="pagination"
                                  linkClass="page-link"
                                  itemClass="page-item"
                                  nextPageText="Next"
                                  prevPageText="Prev"
                                />
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ResetLoginPassword />
              )}
            </>
          )}
          no={
            () => <Redirect to="/emp-list" />
          }
        />
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};

const mapStateToProps = ({
  user: { userRole },
  user: { roMdn },
  role: { roleData },
  token: { authenticated, token, isPasswordReset },
}) => ({
  userRole,
  roMdn,
  roleData,
  authenticated,
  token,
  isPasswordReset,
});

export default connect(mapStateToProps)(CorporateList);
